module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/lwp-a47439684bba9653a23661b4a5f4faaa.svg";